import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

function PerSiteFormatedMessage(props) {
  return (
    <>
      <FormattedMessage id={`${process.env.REACT_APP_SITE_TYPE}.${props.id}`} />
    </>
  );
}

export const usePerSiteMessage = ({ id }) => {
  const intl = useIntl();

  return intl.formatMessage({ id: `${process.env.REACT_APP_SITE_TYPE}.${id}` });
};

export default PerSiteFormatedMessage;
